<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all2 LogoCenter">
    <div class="LogoCenterNav">
      <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="LogoCenterNav_list font18"
        >自由创作(<span>25</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/LetterLogoCenter" class="LogoCenterNav_list font18"
        >字母LOGO(<span>2</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/SameCreationCenter" class="LogoCenterNav_list font18"
        >同款创作(<span>5</span>)</router-link
      >
      <div class="LogoCenterNav_list font18">已保存(<span>77</span>)</div>
      <div class="LogoCenterNav_list font18">已下载(<span>5</span>)</div>
      <div class="LogoCenterNav_list font18 active">解析理念(<span>8</span>)</div>
    </div>
    <div class="LogoCenterContent OScroll" @scroll="handleScroll">
      <div
        v-for="(site, siteIndex) in sites"
        :key="siteIndex"
        :class="['LogoCenterContent_list', { active: activeIndices.includes(siteIndex) }]"
        ref="listItems"
      >
        <div class="LogoCenterContent_logo hover">
          <div v-for="(image, index) in site.logo" :key="index" class="LogoCenterContent_logo_list">
            <img :src="image.png_url" alt="站点图片" class="logo_list_img" />
            <div class="logo_list_btn">
              <router-link to="/ailogo/GenerateManagement/LogoFile" class="list_btn_li font14">
                <img alt="" src="@a/ailogo/images/sv1.svg" />VI资产
              </router-link>
              <a
                  :href="`/#/ailogo/LogoCenter/DeepDesign?tempId=${image.id}`"
                  target="_blank"
                  class="list_btn_li font14"
              >
                <img alt="" src="@a/ailogo/images/sv2.svg" />深度设计
              </a>
              <div class="list_btn_li font14">
                <img alt="" src="@a/ailogo/images/sv3.svg" />下载
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import Header from '@c/header/header'
import ImageModal from '@c/common/ImageModal/ImageModal.vue';

export default {
  data() {
    return {
      isActive: false,
      ExampleWindowActive: false,
      brandInputs: [
        { value: '', focused: false },
        { value: '', focused: false }
      ],
      industries: [
        '餐饮美食',
        '美容美发',
        '健康养生',
        '教育培训',
        '文体娱乐',
        '母婴保育',
        '箱包服饰',
        '家居建材',
        '萌宠服务',
        '商品零售',
        '旅游住宿',
        '汽车服务',
        '房地产',
        '科研服务',
        '生产制造',
        '企业服务',
        '农业服务',
        '公益环保',
        '政务组织',
        '生活服务'
      ],
      activeIndustry: 0,
      keywordInput: '',
      charCount: 0,
      keywords: ['老鼠', '染色体', '药物', '科研', '试用药', 'DNA'],
      activeKeywords: [], // Array to hold active keywords
      styles: ['现代简约', '几何线形', '吉祥物', '美式徽章'],
      activeStyle: 0,
      colors: ['red', 'blue', 'green', 'blue', 'green', 'blue', 'green'],
      activeColor: null,
      otherColorInput: '',
      sites: [], // 原始站点数据
      images: [], // 处理后的图片数组
      intervalId: null,  // 定时器 ID
      // isModalVisible: false,
      // selectedImageUrl: '',
      activeIndices: [], // 跟踪所有触碰顶部的元素索引
    }
  },
  components: {
    Header,
    ImageModal,
  },
  created() {
    this.getImages();
  },
  methods: {
    handleScroll() {
      const container = this.$el; // 获取 LogoCenterContent
      const containerTop = container.getBoundingClientRect().top;

      this.activeIndices = []; // 重置数组，以确保更新当前触碰顶部的元素

      // 遍历每个列表项，判断其是否接触顶部
      this.$refs.listItems.forEach((item, index) => {
        const itemTop = item.getBoundingClientRect().top - 100;

        if (itemTop <= containerTop) {
          if (!this.activeIndices.includes(index)) {
            this.activeIndices.push(index); // 将当前触碰顶部的元素索引添加到 activeIndices
          }
        }
      });
    },
    openModal(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.isModalVisible = true;
    },
    toggleClass() {
      this.isActive = !this.isActive
    },
    ExampleWindowClass() {
      this.ExampleWindowActive = !this.ExampleWindowActive
    },
    handleFocus(index) {
      this.brandInputs[index].focused = true
    },
    handleBlur(index) {
      this.brandInputs[index].focused = false
    },
    isInputFocused(index) {
      return this.brandInputs[index].focused
    },
    isInputWithContent(index) {
      return this.brandInputs[index].value.trim() !== ''
    },
    updateCharCount() {
      this.charCount = this.keywordInput.length
      if (this.charCount > 150) {
        this.keywordInput = this.keywordInput.slice(0, 150)
      }
    },
    clearInput() {
      this.keywordInput = ''
      this.charCount = 0
      this.activeKeywords = [] // Clear all active keywords
    },
    toggleKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      if (keywordIndex !== -1) {
        // Remove item from textarea
        this.removeKeyword(item)
      } else {
        // Add item to textarea
        this.addKeyword(item)
      }

      // Update charCount after the change
      this.updateCharCount()
    },
    addKeyword(item) {
      if (this.keywordInput) {
        this.keywordInput += `, ${item}`
      } else {
        this.keywordInput = item
      }
      this.activeKeywords.push(item)
    },
    removeKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      keywordsArray.splice(keywordIndex, 1)
      this.keywordInput = keywordsArray.join(', ')
      this.activeKeywords = this.activeKeywords.filter((keyword) => keyword !== item)
    },
    selectIndustry(index) {
      this.activeIndustry = index
    },
    selectStyle(index) {
      this.activeStyle = index
    },
    selectColor(index) {
      this.activeColor = index
      this.otherColorInput = '' // Clear other color input if any color is selected
    },
    handleOtherColorInput() {
      if (this.otherColorInput) {
        this.activeColor = null
      }
    },

    async getImages() {
      try {
        const res = await this.axios.get(`api/LogoChoice/historyList`);
        if (res.code === 1) {
          // 检查是否有需要轮询的项目
          const needsPolling = res.result.some(site => site.status !== 2);
          this.sites = res.result.map(site => ({
            ...site,
            progress: site.status === 1 ? 1 : 1  // 初始化进度：生成中为 0，已完成为 100
          }));

          // 启动轮询定时器
          if (needsPolling && !this.intervalId) {
            this.startPolling();
          } else if (!needsPolling && this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        } else {
          console.error("接口返回错误:", res.msg);
        }
      } catch (error) {
        console.error("获取站点时出错:", error.msg);
      }
    },

    startPolling() {
      this.intervalId = setInterval(async () => {
        try {
          // 每次轮询，向接口请求所有任务的生成进度
          const res = await this.axios.get(`api/LogoChoice/historyList`);

          if (res.code === 1) {
            res.result.forEach(async (site, index) => {
              // 如果状态变化，更新状态和图片
              if (site.status !== this.sites[index].status) {
                this.sites[index].status = site.status;
                this.sites[index].logo = site.logo;
              }

              // 仅在任务处于生成中的状态时获取进度
              if (site.status === 1) {
                try {
                  // 使用 unique_id 获取每个任务的生成进度
                  const progressRes = await this.axios.get(`api/LogoChoice/getProgress`, {
                    params: { unique_id: site.unique_id }
                  });

                  if (progressRes.code === 1) {
                    const generated = progressRes.result.generated;  // 已生成的图片数量
                    const imgNum = progressRes.result.img_num;  // 总共需要生成的图片数量

                    // 根据已生成图片数量和总图片数量计算进度
                    const progress = (generated / imgNum) * 100;

                    // 更新进度，确保进度逐渐增加
                    if (this.sites[index].progress < progress) {
                      this.sites[index].progress = progress;
                    }
                  } else {
                    console.error(`获取进度失败: ${progressRes.msg}`);
                  }
                } catch (error) {
                  console.error(`请求进度时出错: ${error.message}`);
                }
              }
            });

            // 检查是否可以停止轮询
            if (this.sites.every(site => site.status === 2)) {
              clearInterval(this.intervalId);
              this.intervalId = null;
            }
          } else {
            console.error("接口返回错误:", res.msg);
          }
        } catch (error) {
          console.error("轮询请求出错:", error.message);
        }
      }, 5000); // 每 5 秒轮询一次
    },

  },
  beforeDestroy() {
    // 组件销毁时停止轮询
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
</script>

<style>
@import "LogoCenter.css";
.progress-container {
  width: 100%;
  position: absolute;
  left: 0;
}

.progress-bar {
  height: 14px;
  background: linear-gradient(90deg, #5d9cec, #4a90e2, #357abd); /* 蓝色渐变 */
  transition: width 0.6s ease;
  border-radius: 8px;
}

.progress-text {
  font-size: 16px;
  font-weight: 600;
  color: #2a3d56; /* 深蓝灰色字体，与背景和进度条配色搭配 */
  text-align: center;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* 旋转加载图标 */
.spinner {
  width: 24px;
  height: 24px;
  border: 4px solid rgba(42, 61, 86, 0.3); /* 深蓝灰色半透明边框 */
  border-top: 4px solid #5d9cec; /* 与进度条呼应的蓝色顶部 */
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-top: 8px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.LogoCenter .LogoCenterContent{ padding-top: 30px;}
.LogoCenter .LogoCenterContent .LogoCenterContent_logo{ padding-top: 0;}
</style>
